
import { PropTypes } from 'prop-types';

const Video = ({ path }) => {
    return (
        <div className="w-full max-w-5xl h-[20rem] my-5 2xl:max-w-7xl 2xl:h-[40rem] overflow-hidden rounded-2xl  bg-gray-200">
            
            <iframe className="max-w-full w-full h-full " src={path} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
        </div>
    )
}
Video.propTypes = {
    path: PropTypes.string
}
export default Video